export const QUESTIONS = [
  {
    key: "stage",
    label: "Where are you right now?",
    options: [["starting", "Just starting out"], ["building", "Building a business"], ["established", "Established business owner"]],
  },
  {
    key: "goal",
    label: "What is your primary goal?",
    options: [["credit", "Improve my credit"], ["funding", "Get prepared for business funding"], ["service-business", "Learn to build a credit/funding service business"]],
  },
  {
    key: "invest",
    label: "Mentorship investments typically range from $3,000 to $8,000. Which best describes you?",
    options: [["ready", "I'm prepared to invest $3,000–$8,000 if it's the right fit"], ["options", "I'm interested and would like to hear about payment options"], ["not", "I'm not financially ready right now"]],
  },
  {
    key: "timeline",
    label: "When are you looking to get started?",
    options: [["immediately", "Immediately"], ["30-days", "Within 30 days"], ["researching", "I'm researching my options"]],
  },
];
